import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export default function AlbumActionConfirm({
  kind,
  hasReview,
  en,
  busy = false,
  error = false,
  onCancel,
  onConfirm,
}) {
  const id = React.useId();
  const discard = kind === 'discard';
  const review = kind === 'review';
  const title = discard
    ? en
      ? 'Discard changes?'
      : '작성 내용 버리기'
    : review
      ? en
        ? 'Delete Review'
        : '리뷰 삭제'
      : en
        ? 'Delete Rating'
        : '평가 삭제';
  const message = discard
    ? en
      ? 'Your unsaved changes will be lost.'
      : '저장하지 않은 작성 내용이 사라집니다.'
    : review
      ? en
        ? 'Your review and rating are saved as one record. Deleting the review will also delete the album rating and cannot be undone.'
        : '현재 리뷰와 평가는 하나의 기록으로 저장됩니다. 리뷰를 삭제하면 앨범 평가도 함께 삭제되며 복구할 수 없습니다.'
      : hasReview
        ? en
          ? 'Your rating and review are saved as one record. Deleting the rating will also delete the review and cannot be undone.'
          : '현재 평가와 리뷰는 하나의 기록으로 저장됩니다. 평가를 삭제하면 작성한 리뷰도 함께 삭제되며 복구할 수 없습니다.'
        : en
          ? 'A deleted rating cannot be recovered.'
          : '삭제한 평가는 복구할 수 없습니다.';
  return (
    <Dialog
      open
      onClose={() => {
        if (!busy) onCancel();
      }}
      disableEscapeKeyDown={busy}
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-message`}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        role: 'alertdialog',
        sx: {
          m: 2,
          width: 'calc(100% - 32px)',
          borderRadius: '16px',
          background: 'var(--pp-surface)',
          color: 'var(--pp-text-primary)',
          fontFamily: 'Pretendard, sans-serif',
          overflowWrap: 'anywhere',
        },
      }}
    >
      <DialogTitle
        id={`${id}-title`}
        sx={{ font: '600 18px/24px Pretendard, sans-serif', p: '20px 20px 12px' }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ px: '20px', pb: 1 }}>
        <p id={`${id}-message`} style={{ font: '400 14px/21px Pretendard, sans-serif', margin: 0 }}>
          {message}
        </p>
        {error && (
          <p role="alert" style={{ font: '400 14px/21px Pretendard, sans-serif', marginBottom: 0 }}>
            {en ? 'Could not delete. Please try again.' : '삭제하지 못했어요. 다시 시도해 주세요.'}
          </p>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          p: '12px 16px 16px',
          gap: 1,
          '& button': {
            minHeight: 44,
            minWidth: 72,
            font: '500 14px/19px Pretendard, sans-serif',
            textTransform: 'none',
            '&:focus-visible': { outline: '2px solid var(--pp-accent, #f16438)', outlineOffset: 1 },
            '&.Mui-disabled': { color: 'var(--pp-text-secondary)', opacity: 0.5 },
          },
        }}
      >
        <Button
          autoFocus
          disabled={busy}
          onClick={onCancel}
          sx={{ color: 'var(--pp-text-secondary)' }}
        >
          {en ? 'Cancel' : '취소'}
        </Button>
        <Button disabled={busy} onClick={onConfirm} sx={{ color: 'var(--pp-accent, #f16438)' }}>
          {busy
            ? en
              ? 'Deleting…'
              : '삭제 중…'
            : discard
              ? en
                ? 'Discard'
                : '버리기'
              : en
                ? 'Delete'
                : '삭제'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
